module.exports = __webpack_public_path__ + "static/img/5-3.1ac3ce3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/components/past-review/5-3.png
// module id = VPly
// module chunks = 25